import React from 'react';
import { Alert, Button, ColorPicker, Form, Input } from 'antd';
import { DeleteOutlined, DownOutlined, PlusOutlined, UpOutlined } from '@ant-design/icons';
import cls from './Project.module.scss';
import CustomUpload from '../../components/Form/Upload/CustomUpload';

export default function ProjectForm({ initialValues, onFinish, loading, edit=false }) {

    const [form] = Form.useForm();

    const levels = Form.useWatch('levels', form)
    const experiences = Form.useWatch('experiences', form)

    const inputLevels = JSON.stringify(initialValues?.levels)
    const formLevels = JSON.stringify(levels)

    const inputExperiences = JSON.stringify(initialValues?.experiences)
    const formExperiences = JSON.stringify(experiences)

    return (
        <Form
            form={form}
            initialValues={initialValues}
            layout={'vertical'}
            size={'large'}
            scrollToFirstError
            onFinish={onFinish}
            disabled={loading}
        >
            <h3>Общие данные</h3>
            <Form.Item
                name={'name'}
                label={'Название проекта'}
                rules={[{ required: true, message: 'Заполните, пожалуйста' }]}
            >
                <Input placeholder={'Название проекта'} />
            </Form.Item>
            <h3>Брендирование</h3>
            <Form.Item name={'color'} label={'Основной цвет'}>
                <ColorPicker showText allowClear defaultFormat={'hex'} format={'hex'} onClear={() => form.setFieldValue('color', null)}/>
            </Form.Item>
            <Form.Item name={'logo'} label={'Логотип'}>
                <CustomUpload imgWidth={200} imgHeight={60} imgFit={'contain'} />
            </Form.Item>
            <Form.Item name={'cover'} label={'Фоновое изображение'}>
                <CustomUpload imgWidth={300} imgHeight={300} imgFit={'cover'}/>
            </Form.Item>

            <h3>Ссылки на соц. сети</h3>
            <Form.List name={'links'}>
                {(fields, { add, remove, move }) => (
                    <div className={cls.grid}>
                        {fields.map(({ key, name, ...restField }) => (
                            <div key={key} className={cls.card}>
                                <h4>{name + 1}</h4>
                                <div className={cls.row}>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'name']}
                                        rules={[{ required: true, message: 'Заполните название' }]}
                                    >
                                        <Input placeholder="Название" />
                                    </Form.Item>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'url']}
                                        rules={[
                                            { required: true, message: 'Заполните url' },
                                            { type: 'url', message: 'Не формат url' },
                                        ]}
                                    >
                                        <Input placeholder="https://example.com" />
                                    </Form.Item>
                                </div>
                                <div className={cls.row}>
                                    <Button
                                        style={{ border: 'none' }}
                                        onClick={() => move(name, name - 1)}
                                        icon={<UpOutlined />}
                                    />
                                    <Button
                                        style={{ border: 'none' }}
                                        onClick={() => move(name, name + 1)}
                                        icon={<DownOutlined />}
                                    />
                                    <Button
                                        style={{ border: 'none' }}
                                        onClick={() => remove(name)}
                                        icon={<DeleteOutlined />}
                                    />
                                </div>
                            </div>
                        ))}
                        <Form.Item>
                            <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                                Добавить ссылку
                            </Button>
                        </Form.Item>
                    </div>
                )}
            </Form.List>

            <h3>Уровни</h3>
            <Form.List name={'levels'}>
                {(fields, { add, remove, move }) => (
                    <div className={cls.grid}>
                        {fields.map(({ key, name, ...restField }) => (
                            <div key={key} className={cls.card}>
                                <h4>{name + 1}</h4>
                                <div>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'name']}
                                        rules={[{ required: true, message: 'Заполните название' }]}
                                    >
                                        <Input placeholder="Название" />
                                    </Form.Item>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'color']}
                                        label={'Основной цвет'}
                                    >
                                        <ColorPicker showText allowClear defaultFormat={'hex'} format={'hex'} onClear={() => form.setFieldValue(['levels', name, 'color'], null)}/>
                                    </Form.Item>
                                    <Form.Item {...restField} name={[name, 'image']} label={'Картинка'}>
                                        <CustomUpload imgWidth={200} imgHeight={200} imgFit={'contain'} />
                                    </Form.Item>
                                </div>
                                <div className={cls.row}>
                                    <Button
                                        style={{ border: 'none' }}
                                        onClick={() => move(name, name - 1)}
                                        icon={<UpOutlined />}
                                    />
                                    <Button
                                        style={{ border: 'none' }}
                                        onClick={() => move(name, name + 1)}
                                        icon={<DownOutlined />}
                                    />
                                    <Button
                                        style={{ border: 'none' }}
                                        onClick={() => remove(name)}
                                        icon={<DeleteOutlined />}
                                    />
                                </div>
                            </div>
                        ))}
                        <Form.Item>
                            <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                                Добавить уровень
                            </Button>
                        </Form.Item>
                    </div>
                )}
            </Form.List>

            <h3>Навыки</h3>
            <Form.List name={'experiences'}>
                {(fields, { add, remove, move }) => (
                    <div className={cls.grid}>
                        {fields.map(({ key, name, ...restField }) => (
                            <div key={key} className={cls.card}>
                                <h4>{name + 1}</h4>
                                <div>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'name']}
                                        rules={[{ required: true, message: 'Заполните название группы' }]}
                                    >
                                        <Input placeholder="Название группы" />
                                    </Form.Item>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'description']}
                                    >
                                        <Input.TextArea autoSize={{ minRows: 2, maxRows: 4 }} placeholder="Комментарий (описание группы)" />
                                    </Form.Item>
                                    <Form.Item
                                        {...restField}
                                        name={[name, 'list']}
                                        rules={[{ required: true, message: 'Заполните список навыков' }]}
                                        label={'Список навыков (каждый с новой строки)'}
                                    >
                                        <Input.TextArea
                                            autoSize={{ minRows: 4, maxRows: 10 }}
                                            placeholder={`Удержание баланса
Прыгучесть
Координация`}
                                        />
                                    </Form.Item>
                                </div>
                                <div className={cls.row}>
                                    <Button
                                        style={{ border: 'none' }}
                                        onClick={() => move(name, name - 1)}
                                        icon={<UpOutlined />}
                                    />
                                    <Button
                                        style={{ border: 'none' }}
                                        onClick={() => move(name, name + 1)}
                                        icon={<DownOutlined />}
                                    />
                                    <Button
                                        style={{ border: 'none' }}
                                        onClick={() => remove(name)}
                                        icon={<DeleteOutlined />}
                                    />
                                </div>
                            </div>
                        ))}
                        <Form.Item>
                            <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                                Добавить группу
                            </Button>
                        </Form.Item>
                    </div>
                )}
            </Form.List>

            {(edit && formLevels !== inputLevels) &&
                <div style={{marginBottom: 16}}>
                    <Alert styles={{marginBottom: 8}} type={'warning'} message={'Изменение уровней'} description={'После изменения уровней будет произведен пересчет назначенных уровней у пользователей'}/>
                </div>
            }
            {(edit && formExperiences !== inputExperiences) &&
                <div style={{marginBottom: 16}}>
                    <Alert styles={{marginBottom: 8}} type={'warning'} message={'Изменение навыков'} description={'После изменения навыков будет произведен пересчет назначенных навыков и уровней у пользователей, исправление ошибок будет считается как создание нового навыка'}/>
                </div>
            }

            <Form.Item>
                <Button type={'primary'} htmlType={'submit'} loading={loading}>
                    {edit ? 'Сохранить' : 'Добавить'}
                </Button>
            </Form.Item>
        </Form>
    );
}
